import { render, staticRenderFns } from "./PeopleCreateAndUpdateFormItems.vue?vue&type=template&id=7c98b392&"
import script from "./PeopleCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./PeopleCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c98b392')) {
      api.createRecord('7c98b392', component.options)
    } else {
      api.reload('7c98b392', component.options)
    }
    module.hot.accept("./PeopleCreateAndUpdateFormItems.vue?vue&type=template&id=7c98b392&", function () {
      api.rerender('7c98b392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PeopleCreateAndUpdateFormItems.vue"
export default component.exports